import React from 'react';
import PropTypes from 'prop-types';
import { withHandlers } from 'recompose';
import { Button } from 'components/core/Button';
import { SFIcon } from 'components/core/SFIcon';

export const enhance = withHandlers({
	handleClick: ({ index, onClick }) => () => onClick(index)
});

export function DotControl({ handleClick, slideShowing }) {
	return (
		<li className="dot">
			<Button
				onClick={handleClick}
				primary={false}
			>
				<SFIcon icon={`${slideShowing ? 'circle' : 'circle-o'}`} />
			</Button>
		</li>
	);
}

DotControl.propTypes = {
	handleClick: PropTypes.func,
	slideShowing: PropTypes.bool
};
export default enhance(DotControl);
